import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgVerified(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12a4.083 4.083 0 0 0-2.35-3.585 4.066 4.066 0 0 0-.87-4.196 4.067 4.067 0 0 0-4.196-.869A4.06 4.06 0 0 0 12 1a4.054 4.054 0 0 0-3.574 2.35 4.065 4.065 0 0 0-2.227-.163 4.056 4.056 0 0 0-1.978 1.032 4.051 4.051 0 0 0-1.028 1.977 4.052 4.052 0 0 0 .168 2.22A4.085 4.085 0 0 0 1 12a4.092 4.092 0 0 0 2.361 3.585 4.064 4.064 0 0 0 .858 4.196 4.086 4.086 0 0 0 4.196.867A4.083 4.083 0 0 0 12 23a4.07 4.07 0 0 0 3.585-2.35 3.905 3.905 0 0 0 5.064-5.065A4.082 4.082 0 0 0 23 12Zm-6.293-2.707a1 1 0 0 0-1.414 0L11 13.586l-1.793-1.793a1 1 0 1 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0 0-1.414Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgVerified)
